export var powerZoneDefinitions = {
    easy: {
        title: 'Easy',
        percentLow: 65,
        percentHigh: 80,
        target: 72.5
    },
    moderate: {
        title: 'Moderate',
        percentLow: 80,
        percentHigh: 90,
        target: 85
    },
    threshold: {
        title: 'Threshold',
        percentLow: 90,
        percentHigh: 100,
        target: 95
    },
    interval: {
        title: 'Interval',
        percentLow: 100,
        percentHigh: 115,
        target: 107.5
    },
    repetition: {
        title: 'Repetition',
        percentLow: 115,
        percentHigh: 130,
        target: 122.5
    }
};
//# sourceMappingURL=constants.js.map